import { useApi } from './use-api-call';


export const useSearchSysMenuGroupApi = () => useApi<{ 
sysMenuGroups: SysMenuGroupDTO[];
        allowEdit: boolean; 
    }>('/sys-menu-group/search-sys-menu-group');

export const useGetSysMenuGroupApi = () => useApi<{ sysMenuGroup: SysMenuGroupDTO; allowEdit: boolean; }>('/sys-menu-group/get-sys-menu-group/{id}');

export const useSaveSysMenuGroupApi = () => useApi<{ sysMenuGroup: SysMenuGroupDTO}>('/sys-menu-group/save-sys-menu-group');

export const useDeleteSysMenuGroupApi = () => useApi('/sys-menu-group/delete-sys-menu-group/{id}');

export interface SysMenuGroupDTO { 
id:string;
title:string;
subTitle:string;
iconCode:string;
iconCss:string;
sortOrder:number;
templateCode:string;
}
